import { useQuery } from '@tanstack/react-query'
import useStore from '../../util/store/auth'
import { queryKeys } from '../queryKeys'
import { auditAiRequest } from '../../util/api/audit-ai-api'
import checkToken from '../../util/auth/checkToken'
import type { DashboardFilterOptionsResponse } from '@counsel-project/counsel-audit-ai-api'

export const useDashboardFilterOptions = () => {
  const { directory } = useStore()

  return useQuery<DashboardFilterOptionsResponse['results']>({
    queryKey: queryKeys.dashboardFilterOptions(directory?._id ?? ''),
    queryFn: async () => {
      await checkToken()

      const { results } = await auditAiRequest.dashboard.filterOptions({
        token: '',
        directoryId: directory?._id ?? '',
      })
      return results
    },
    enabled: !!directory?._id,
  })
}
